<template>
  <div class="summary-box">
    <div class="title">课程总结</div>
    <div class="cont">
      <div class="text" :class="showMore ? '':'showTwoText'">{{ currentVideo && currentVideo.summary }}</div>
      <div class="open" @click="showMore = !showMore">
        <span class="label">{{ showMore ? '收起' : '更多' }}</span>
        <img width="12" height="7" class="down-arrow" v-if="!showMore"
             src="@/assets/images/course/icon-arrowDown.png"/>
        <img width="12" height="7" class="down-arrow" v-else src="@/assets/images/course/icon-arrowUp.png"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CourseSummary',
  props: {
    currentVideo: {
      type: Object
    }
  },
  data() {
    return {
      showMore: false
    }
  },
  watch: {},
  mounted() {
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.summary-box {
  background: #fff;
  border-radius: 9px;
  margin-bottom: 15px;

  .title {
    border-bottom: none;
    height: 40px;
    display: flex;
    align-items: center;
    padding: 0 16px;
    border-radius: 10px 10px 0 0;
    font-size: 14px;
    font-weight: bold;
    color: #1f333f;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .cont {
    white-space: break-spaces;
    word-break: break-all;
    padding: 0 16px 10px;
    display: flex;
    align-items: flex-end;
    color: #5F5F5F;
    font-size: 12px;

    .text {
      flex: 1;

      &.showTwoText {
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }

    }

    .open {
      cursor: pointer;
      padding-right: 25px;
      display: flex;
      align-items: center;
      .label {
        font-size: 12px;
        font-weight: 500;
        color: #1f333f;
        margin-right: 6px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/course/components/CourseSummary.vue